import {
  CalendarDays, Handshake, LifeBuoy, UserCog, MessageSquare,
  LayoutDashboard, Users, FileText, FileSpreadsheet, Link2, Stamp,
  CreditCard, Repeat, Download, Bot, BarChart3, ShieldCheck, Wallet,
  ScrollText, Settings, GraduationCap, type LucideIcon, ListTodo, Ticket } from 'lucide-react';
import type { Capability } from '@/lib/permissions';

export interface NavItem {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  capability?: Capability;
  group: 'main' | 'finance' | 'system';
}

// Module map (matches the 14 VaulTex modules). Visibility is gated by capability.
export const NAV_ITEMS: NavItem[] = [
  { to: '/', labelKey: 'nav.dashboard', icon: LayoutDashboard, group: 'main' },
  { to: '/tasks', labelKey: 'nav.tasks', icon: ListTodo, capability: 'tasks.use', group: 'main' },
  { to: '/clients', labelKey: 'nav.clients', icon: Users, capability: 'clients.read', group: 'main' },
  { to: '/documents', labelKey: 'nav.documents', icon: FileText, capability: 'documents.read', group: 'main' },
  { to: '/tax-returns', labelKey: 'nav.taxReturns', icon: FileSpreadsheet, capability: 'tax_returns.read', group: 'main' },
  { to: '/portal', labelKey: 'nav.portal', icon: Link2, capability: 'portal.manage', group: 'main' },
  { to: '/appointments', labelKey: 'nav.appointments', icon: CalendarDays, group: 'main' },
  { to: '/queue', labelKey: 'nav.queue', icon: Ticket, capability: 'queue.use', group: 'main' },
  { to: '/messages', labelKey: 'nav.messages', icon: MessageSquare, capability: 'messages.use', group: 'main' },
  { to: '/crm', labelKey: 'nav.crm', icon: Handshake, capability: 'crm.use', group: 'main' },
  { to: '/notarization', labelKey: 'nav.notarization', icon: Stamp, group: 'main' },
  { to: '/payments', labelKey: 'nav.payments', icon: CreditCard, capability: 'payments.read', group: 'finance' },
  { to: '/subscriptions', labelKey: 'nav.subscriptions', icon: Repeat, capability: 'subscriptions.manage', group: 'finance' },
  { to: '/billing', labelKey: 'nav.billing', icon: Wallet, capability: 'subscriptions.manage', group: 'finance' },
  { to: '/downloads', labelKey: 'nav.downloads', icon: Download, capability: 'documents.download', group: 'finance' },
  { to: '/assistant', labelKey: 'nav.ai', icon: Bot, capability: 'ai.use', group: 'main' },
  { to: '/reports', labelKey: 'nav.reports', icon: BarChart3, capability: 'reports.read', group: 'system' },
  { to: '/audit', labelKey: 'nav.audit', icon: ScrollText, capability: 'audit.read', group: 'system' },
  { to: '/security', labelKey: 'nav.security', icon: ShieldCheck, capability: 'security.manage', group: 'system' },
  { to: '/sandbox', labelKey: 'nav.sandbox', icon: GraduationCap, capability: 'sandbox.use', group: 'system' },
  { to: '/team', labelKey: 'nav.team', icon: UserCog, capability: 'team.manage', group: 'system' },
  { to: '/support', labelKey: 'nav.support', icon: LifeBuoy, group: 'system' },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings, group: 'system' },
];
